import { EmbeddingCollectionList } from '@/Workspaces/EmbeddingCollection/EmbeddingCollectionList'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/workspace/$workspaceId/embeddingCollection/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <EmbeddingCollectionList />
}
